var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 140 140",
    style: {
      enableBackground: "new 0 0 140 140"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:url(#SVGID_5_);}\n\t.st5{fill:url(#SVGID_6_);}\n\t.st6{fill:url(#SVGID_7_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 12,
    y1: 72,
    x2: 127.71,
    y2: 72,
    gradientTransform: "matrix(1 0 0 -1 0 142)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCE44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7344,
    style: {
      stopColor: "#FF7B01"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7B01"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M119.9,0H40.4c-4.3,0-7.8,3.5-7.8,7.8v12.8H19.8c-4.3,0-7.8,3.5-7.8,7.8v103.8c0,4.3,3.5,7.8,7.8,7.8h79.5 c4.3,0,7.8-3.5,7.8-7.8v-12.8h12.8c4.3,0,7.8-3.5,7.8-7.8V7.8C127.6,3.5,124.2,0,119.9,0z M100.8,132.1c0,0.7-0.6,1.3-1.5,1.3H19.8 c-0.7,0-1.3-0.6-1.3-1.3V28.3c0-0.7,0.6-1.3,1.3-1.3h12.8v84.6c0,4.3,3.5,7.8,7.8,7.8h60.4V132.1z M121.2,111.6 c0,0.7-0.6,1.5-1.5,1.5H40.4c-0.7,0-1.5-0.6-1.5-1.5V7.8c0-0.7,0.6-1.5,1.5-1.5h79.5c0.7,0,1.5,0.6,1.5,1.5v103.8H121.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.2188,
    y1: 64.1236,
    x2: 106.952,
    y2: 64.1236,
    gradientTransform: "matrix(1 0 0 -1 0 142)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCE44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7344,
    style: {
      stopColor: "#FF7B01"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7B01"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.7,74.6H56.5c-1.8,0-3.2,1.5-3.2,3.2c0,1.8,1.5,3.2,3.2,3.2h47.3c1.8,0,3.2-1.5,3.2-3.2 C107,76.1,105.5,74.6,103.7,74.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.2188,
    y1: 44.9858,
    x2: 106.952,
    y2: 44.9858,
    gradientTransform: "matrix(1 0 0 -1 0 142)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCE44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7344,
    style: {
      stopColor: "#FF7B01"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7B01"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M103.7,93.8H56.5c-1.8,0-3.2,1.5-3.2,3.2s1.5,3.2,3.2,3.2h47.3c1.8,0,3.2-1.5,3.2-3.2S105.5,93.8,103.7,93.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.2188,
    y1: 83.1148,
    x2: 106.952,
    y2: 83.1148,
    gradientTransform: "matrix(1 0 0 -1 0 142)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCE44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7344,
    style: {
      stopColor: "#FF7B01"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7B01"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M103.7,55.6H56.5c-1.8,0-3.2,1.5-3.2,3.2c0,1.8,1.5,3.2,3.2,3.2h47.3c1.8,0,3.2-1.5,3.2-3.2 C107,57,105.5,55.6,103.7,55.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.873,
    y1: 104.3133,
    x2: 68.9698,
    y2: 104.3133,
    gradientTransform: "matrix(1 0 0 -1 0 142)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCE44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7344,
    style: {
      stopColor: "#FF7B01"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7B01"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M62.1,43.4h5.7c0.7,0,1.2-0.6,1.2-1.2v-9.1c0-0.7-0.6-1.2-1.2-1.2h-5.7c-0.7,0-1.2,0.6-1.2,1.2v9.1 C60.9,42.8,61.5,43.4,62.1,43.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.1562,
    y1: 107.6251,
    x2: 83.253,
    y2: 107.6251,
    gradientTransform: "matrix(1 0 0 -1 0 142)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCE44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7344,
    style: {
      stopColor: "#FF7B01"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7B01"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M76.3,43.4h5.7c0.7,0,1.2-0.6,1.2-1.2V26.5c0-0.7-0.6-1.2-1.2-1.2h-5.7c-0.7,0-1.2,0.6-1.2,1.2v15.6 C75.2,42.8,75.7,43.4,76.3,43.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 89.4336,
    y1: 110.7901,
    x2: 97.5303,
    y2: 110.7901,
    gradientTransform: "matrix(1 0 0 -1 0 142)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCE44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7344,
    style: {
      stopColor: "#FF7B01"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7B01"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M90.6,43.4h5.7c0.7,0,1.2-0.6,1.2-1.2V20.2c0-0.6-0.6-1.2-1.2-1.2h-5.7c-0.7,0-1.2,0.6-1.2,1.2v22.1 C89.4,42.8,90,43.4,90.6,43.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.8411001762396c73b8b5559369dd6716.svg";
export { ForwardRef as ReactComponent };